<template>
  <v-container>
    <GoBackAtTop :to="{name: 'CompanyEmployees', params: {id: $route.params.id}}" :label="$t('labels.staff')" />
    <h1>{{ $t('roles.add-employee') }}</h1>

    <MessageBox type="info" class="mt-6 my-4">
      <h6>{{ $t('company.mb-add-apprentice-title') }}</h6>
      <p v-html="$t('company.mb-add-apprentice-text')"></p>
      <p>
        <a target="_blank" :href="'/company/' + $route.params.id + '/create-applications'">{{
          $t('company.mb-add-apprentice-link')
        }}</a>
      </p>
    </MessageBox>
    <h4 class="mb-5">{{ $t('labels.staff-roll') }}</h4>
    <v-form ref="form" lazy-validation>
      <v-text-field
        outlined
        :label="$t('fields.personalnumber')"
        v-model="employee.personalNumber"
        v-mask="mask"
        :rules="[rules.required, rules.pnr13, rules.swePnr]"
        required
      ></v-text-field>
      <v-text-field
        outlined
        :label="$t('fields.mobilephone')"
        v-model="employee.mobilephone"
        :rules="[rules.required, rules.phone]"
      ></v-text-field>
      <v-text-field
        outlined
        :label="$t('fields.email')"
        v-model="employee.email"
        :rules="[rules.required, rules.email]"
      ></v-text-field>

      <v-text-field
        outlined
        :label="$t('fields.staff-roleDescription')"
        v-model="employee.roleDescription"
      ></v-text-field>

      <h4 class="mt-6">{{ $t('labels.roles') }}</h4>
      <template v-if="hasDepartments($route.params.id) == false">
        <v-row class="justify-space-between" no-gutters v-if="isAdministrator">
          <v-col cols="10">
            <h5>{{ $t('roles.admin') }}</h5>
          </v-col>
          <v-col cols="2">
            <v-switch class="white-switch" dense hide-details v-model="employee.isAdministrator"></v-switch>
          </v-col>
        </v-row>
        <p class="mt-n3 mb-6" v-if="isAdministrator">{{ $t('roles.adm-desc') }}</p>

        <template v-if="isAdministrator || isDepartmentAdministrator($route.params.id)">
          <v-row class="justify-space-between mt-2" no-gutters>
            <v-col cols="10">
              <h5>{{ $t('roles.gb') }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch
                class="white-switch"
                dense
                hide-details
                v-model="employee.isDistanceEducationAdministrator"
              ></v-switch>
            </v-col>
          </v-row>
          <p class="mt-n3 mb-6">{{ $t('roles.dua-desc') }}</p>
        </template>

        <template v-if="isAdministrator || isDepartmentAdministrator($route.params.id)">
          <v-row class="justify-space-between mt-2" no-gutters>
            <v-col cols="10">
              <h5>{{ $t('roles.yua') }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch
                class="white-switch"
                dense
                hide-details
                v-model="employee.isCompanyEducationResponsible"
              ></v-switch>
            </v-col>
          </v-row>
          <p class="mt-n3 mb-6">{{ $t('roles.yua-desc') }}</p>
        </template>

        <template
          v-if="
            isAdministrator ||
            isDepartmentAdministrator($route.params.id) ||
            isCompanyEducationResponsible($route.params.id)
          "
        >
          <v-row class="justify-space-between mt-2" no-gutters>
            <v-col cols="10">
              <h5>{{ $t('roles.hl') }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch class="white-switch" dense hide-details v-model="employee.isInstructor"></v-switch>
            </v-col>
          </v-row>
          <p class="mt-n3 mb-6">{{ $t('roles.hl-desc') }}</p>
        </template>

        <template v-if="isAdministrator">
          <h4 :style="{ marginTop: '5rem !important' }">{{ $t('labels.protected') }}</h4>
          <v-row class="justify-space-between" no-gutters>
            <v-col cols="10">
              <p>{{ $t('company.employee.protected-description') }}</p>
            </v-col>
            <v-col cols="2">
              <v-switch class="white-switch" dense hide-details v-model="employee.isProtected"></v-switch>
            </v-col>
          </v-row>
        </template>
      </template>

      <template v-else>
        <template v-if="isAdministrator">
          <v-row class="justify-space-between pt-6" no-gutters>
            <v-col cols="10">
              <h5>{{ $t('roles.admin') }}</h5>
            </v-col>
            <v-col cols="2">
              <v-switch class="white-switch" dense hide-details v-model="employee.isAdministrator"></v-switch>
            </v-col>
            <v-col cols="12" class="mt-n2">
              <p>{{ $t('roles.admin-text') }}</p>
            </v-col>
          </v-row>
          <!-- <p class="mt-n3 mb-6">{{ $t("roles.adm-desc") }}</p> -->
        </template>

        <v-row
          class="justify-space-between pt-4"
          no-gutters
          v-if="isDepartmentAdministrator($route.params.id) || isAdministrator"
        >
          <v-col cols="10">
            <h5>{{ $t('roles.dep-admin') }}</h5>
          </v-col>
          <v-col cols="2">
            <v-switch class="white-switch" dense hide-details v-model="isDepartmentAdministrator_switch"></v-switch>
          </v-col>
          <v-col cols="12" class="mt-n2">
            <p>{{ $t('roles.dep-text') }}</p>
          </v-col>
        </v-row>
        <v-select
          v-if="isDepartmentAdministrator_switch == true"
          v-model="departmentAdministrator_deps"
          :items="departments"
          :rules="[rules.hasDepartments]"
          item-value="value"
          item-text="text"
          :label="$t('company.sections')"
          chips
          outlined
          append-icon="$sl-arrow-down"
          multiple
        >
          <template v-slot:selection="{attrs, item, selected}">
            <v-chip
              close-icon="$sl-close"
              v-bind="attrs"
              :disabled="item.disabled"
              :input-value="selected"
              close
              @click:close="removeAdmin(item)"
              >{{ item.text }}</v-chip
            >
          </template>
        </v-select>

        <v-row
          class="justify-space-between mt-3"
          no-gutters
          v-if="isDepartmentAdministrator($route.params.id) || isAdministrator"
        >
          <v-col cols="10">
            <h5>{{ $t('roles.gb') }}</h5>
          </v-col>
          <v-col cols="2">
            <v-switch
              class="white-switch"
              dense
              hide-details
              v-model="isDistanceEducationAdministrator_switch"
            ></v-switch>
          </v-col>
          <v-col cols="12" class="mt-n2">
            <p>{{ $t('roles.gb-text') }}</p>
          </v-col>
        </v-row>
        <v-select
          v-if="isDistanceEducationAdministrator_switch == true"
          v-model="distanceEducationAdministrator_deps"
          :items="departments"
          item-value="value"
          item-text="text"
          :label="$t('company.sections')"
          chips
          :rules="[rules.hasDepartments]"
          outlined
          append-icon="$sl-arrow-down"
          multiple
        >
          <template v-slot:selection="{attrs, item, selected}">
            <v-chip
              close-icon="$sl-close"
              v-bind="attrs"
              :input-value="selected"
              :disabled="item.disabled"
              close
              @click:close="removeDistance(item)"
              >{{ item.text }}</v-chip
            >
          </template>
        </v-select>

        <v-row
          class="justify-space-between mt-3"
          no-gutters
          v-if="isDepartmentAdministrator($route.params.id) || isAdministrator"
        >
          <v-col cols="10">
            <h5>{{ $t('roles.yua') }}</h5>
          </v-col>
          <v-col cols="2">
            <v-switch class="white-switch" dense hide-details v-model="isCompanyEducationResponsible_switch"></v-switch>
          </v-col>
          <v-col cols="12" class="mt-n2">
            <p>{{ $t('roles.yua-text') }}</p>
          </v-col>
        </v-row>

        <v-select
          v-if="isCompanyEducationResponsible_switch == true"
          v-model="companyEducationResponsible_deps"
          :items="departments"
          item-value="value"
          item-text="text"
          :label="$t('company.sections')"
          chips
          :rules="[rules.hasDepartments]"
          outlined
          append-icon="$sl-arrow-down"
          multiple
          class=""
        >
          <template v-slot:selection="{attrs, item, selected}">
            <v-chip
              close-icon="$sl-close"
              v-bind="attrs"
              :input-value="selected"
              :disabled="item.disabled"
              close
              @click:close="removeYUA(item)"
              >{{ item.text }}</v-chip
            >
          </template>
        </v-select>
        <!-- <p class="mt-n3 mb-6">{{ $t("roles.yua-desc") }}</p> -->
        <v-row
          class="justify-space-between mt-3"
          no-gutters
          v-if="
            isDepartmentAdministrator($route.params.id) ||
            isAdministrator ||
            isCompanyEducationResponsible($route.params.id)
          "
        >
          <v-col cols="10">
            <h5>{{ $t('roles.hl') }}</h5>
          </v-col>
          <v-col cols="2">
            <v-switch class="white-switch" dense hide-details v-model="isInstructor_switch"></v-switch>
          </v-col>
          <v-col cols="12" class="mt-n2">
            <p>{{ $t('roles.hl-text') }}</p>
          </v-col>
        </v-row>
        <v-select
          v-if="isInstructor_switch == true"
          v-model="instructor_deps"
          :items="departments"
          item-value="value"
          item-text="text"
          :label="$t('company.sections')"
          :rules="[rules.hasDepartments]"
          chips
          outlined
          append-icon="$sl-arrow-down"
          multiple
          class=""
        >
          <template v-slot:selection="{attrs, item, selected}">
            <v-chip
              close-icon="$sl-close"
              v-bind="attrs"
              :disabled="item.disabled || isImitatingUser()"
              :input-value="selected"
              close
              @click:close="removeInstructor(item)"
              >{{ item.text }}</v-chip
            >
          </template>
        </v-select>
      </template>
    </v-form>

    <ActionButton class="my-9" @click="saveEmployee" actionIcon="$sl-add" :isDisabled="isImitatingUser()">{{ $t('labels.add') }}</ActionButton>
    <!-- <p class="mt-6">{{ $t('roles.add-button-text') }}</p> -->
    <LinkWorkplaceModal
      :show="openLinkWorkplace"
      :linkedWp="employee.workplaces"
      @linked="linkWorkplace"
      @close="openLinkWorkplace = false"
    />
  </v-container>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import API from '@/services/api.js'
import GoBackAtTop from '@/components/Common/GoBackAtTop'
import {RulesMixin, CompanyRoles} from '@/components/mixins'
import ActionButton from '@/components/Common/ActionButton'
import LinkWorkplaceModal from '@/components/Company/LinkWorkplaceModal'
import {mask} from 'vue-the-mask'
import find from 'lodash/find'
import findIndex from 'lodash/findIndex'
import MessageBox from '@/components/Common/MessageBox'

// @group Company
// CompanyNewEmployee component
export default {
  name: 'CompanyNewEmployee',

  mixins: [RulesMixin, CompanyRoles],

  directives: {
    mask
  },

  components: {
    GoBackAtTop,
    ActionButton,
    LinkWorkplaceModal,
    MessageBox
  },

  data: () => ({
    mask: '########-####',
    employee: {},
    openLinkWorkplace: false,
    departments: [],
    instructor_deps: [],
    companyEducationResponsible_deps: [],
    distanceEducationAdministrator_deps: [],
    departmentAdministrator_deps: [],
    isDistanceEducationAdministrator_switch: false,
    isInstructor_switch: false,
    isDepartmentAdministrator_switch: false,
    isCompanyEducationResponsible_switch: false
  }),

  created() {
    this.init()
    if (this.hasDepartments(this.$route.params.id) == true) {
      this.listDepartments()
    }
  },

  watch: {
    'employee.isProtected': {
      handler(value) {
        if ( value )
          return this.confirmSettingProtected()
      }
    },
  },

  computed: {
    ...mapGetters('currentuser', [
      'currentUser',
      'isApprentice',
      'isCompanyUser',
      'isInstructor',
      'isAdministrator',
      'isCompanyEducationResponsible',
      'isDistanceEducationAdministrator',
      'isDepartmentAdministrator',
      'isImitatingUser',
    ])
  },
  methods: {
    /**
     * @vuese
     * Used to Initialize an empty employee object
     */
    init() {
      this.employee = {
        personalNumber: '',
        email: '',
        mobilephone: '',
        roleDescription: '',
        workplaces: [],
        instructor_deps: [],
        companyEducationResponsible_deps: [],
        distanceEducationAdministrator_deps: [],
        departmentAdministrator_deps: [],
        isAdministrator: false,
        isDistanceEducationAdministrator: false,
        isCompanyEducationResponsible: false,
        isInstructor: false,
        companyId: this.$route.params.id
      }
    },
    async confirmSettingProtected() {
      const res = await this.$dialog.confirm({
        title: this.$t('company.employee.confirmation-title'),
        text: this.$t('company.employee.confirmation-text'),
        actions: [
          {text: this.$t('labels.no'), key: false, icon: '$sl-cancel', outlined: true},
          {text: this.$t('labels.yes'), key: true, icon: '$sl-like'}
        ]
      })

      if (res !== true) {
        this.employee.isProtected = false
        return
      }
    },
    removeAdmin(item) {
      this.departmentAdministrator_deps.splice(this.departmentAdministrator_deps.indexOf(item.value), 1)
    },
    removeDistance(item) {
      this.distanceEducationAdministrator_deps.splice(this.distanceEducationAdministrator_deps.indexOf(item.value), 1)
    },
    removeYUA(item) {
      this.companyEducationResponsible_deps.splice(this.companyEducationResponsible_deps.indexOf(item.value), 1)
    },
    removeInstructor(item) {
      this.instructor_deps.splice(this.instructor_deps.indexOf(item.value), 1)
    },

    listDepartments() {
      if (!(this.$route && this.$route.params && this.$route.params.id)) return

      API.listDepartments(this.$route.params.id)
        .then(response => {
          //console.log("list::", response.data)
          let emp = this.currentUser.employments.find(x => x.companyId == this.$route.params.id)
          let isDis = false
          response.data.forEach(d => {
            isDis = true
            if (this.isAdministrator) {
              isDis = false
            } else if (this.hasDepartmentId(emp, d.id) == true) {
              isDis = false
            } else if (
              this.hasDepartmentIdForRole(emp, d.id, 'isDepartmentEducationResponsible') ||
              this.hasDepartmentIdForRole(emp, d.id, 'isDepartmentDistanceEducationAdministrator')
            ) {
              isDis = false
            }

            this.departments.push({text: d.name, value: d.id, disabled: isDis})
          })
          // this.departments = response.data.map(o => {
          //   return {
          //     text: o.name,
          //     value: o.id
          //   }
          // })
        })
        .catch(error => {
          console.log('There was an error:', error)
        })
    },
    /**
     * @vuese
     * Used to link the workplace
     * @arg called in an object representing workplace object
     */
    linkWorkplace(wp) {
      this.openLinkWorkplace = false
      this.employee.workplaces = wp
    },
    /**
     * @vuese
     * Used to unlink the workplace
     * @arg called in an object representing workplace object
     */
    unLinkWorkplace(wp) {
      let idx = findIndex(this.employee.workplaces, ['id', wp.id])
      if (idx > -1) {
        this.employee.workplaces.splice(idx, 1)
      }
    },
    /**
     * @vuese
     * Used to create Employee if form is valid and push it after to company employees list
     * @arg The argument is an object representing employee
     */
    saveEmployee() {
      if (!this.$refs.form.validate()) {
        this.$events.fire('showError', this.$t('errors.form-validation'))
        return
      }
      if (this.hasDepartments(this.$route.params.id)) {
        this.employee.instructorDepartmentIds = this.instructor_deps
        this.employee.educationResponsibleDepartmentIds = this.companyEducationResponsible_deps
        this.employee.distanceEducationAdministratorDepartmentIds = this.distanceEducationAdministrator_deps
        this.employee.administratorDepartmentIds = this.departmentAdministrator_deps
      }

      API.createEmployed({data: this.employee})
        .then(response => {
          this.$events.fire('showInfo', {message: this.$t('success.person-added'), timeout: 4000})
          //- Back tolist
          return new Promise(resolve => {
            setTimeout(() => {
              this.$nextTick(() => {
                this.$router.push({
                  name: 'CompanyEmployees',
                  params: {id: this.$route.params.id}
                })
              })
            }, 1000)
          })
        })
        .catch(error => {
          if (error.response && error.response.err == '1') {
            this.$events.fire('showError', this.$t('errors.save-failure-already-in-system'))
          } else this.$events.fire('showError', this.$t('errors.save-failure'))
          console.log('There was an error:', error)
        })
    }
  }
}
</script>

<style lang="scss"></style>
